import React from "react";
const AvailabitlityCheckFeedback = ({
  failedEmail,
  isValidZipcode,
  isAvailable,
  isLoggedIn
}: {
  failedEmail: boolean;
  isValidZipcode: boolean;
  isAvailable: boolean;
  isLoggedIn: boolean;
}) => {
  let content = "Installation services are available to your area!";
  if (failedEmail) {
    content = "An error has occured. Please verify your information is correct.";
  } else if (!isValidZipcode) {
    content = "Please enter a valid ZIP Code";
  } else if (!isAvailable) {
    content = "Installation services are not available in your area. Enter your email address if you are interested in Installation services for your area.";
  } else if (isLoggedIn) {
    content = "That zipcode is within our install network! Please change your default shipping address to the one that matches the zip code you entered. This will allow you to order installation services with your item!";
  }
  const afterLoginRedirectUrl = window.location.href.replace(`${window.location.protocol}//${window.location.host}`, "");
  return <p className="p-3 mt-4 mx-auto border border-solid border-blue-300 rounded bg-blue-50 text-xs leading-tight" data-testid="zipcode-check-feedback" data-sentry-component="AvailabitlityCheckFeedback" data-sentry-source-file="AvailabitlityCheckFeedback.tsx">
      {content}
      {isAvailable && !isLoggedIn && <>
          <br />
          <a href={`/myaccount/?target_url=${encodeURIComponent(afterLoginRedirectUrl)}`} title="Login for more information">
            Login for more information &gt;
          </a>
        </>}
    </p>;
};
export default AvailabitlityCheckFeedback;